import { useQuery } from "react-query";

import { GeomBinModel, getGeomBin } from "api/data";

interface UseGeomBinDataOptions {
  enabled?: boolean;
  onError?: (error: Error) => void;
  onSuccess?: (data: GeomBinModel) => void;
}

const useGeomBinData = (geomBinId: string | null, options?: UseGeomBinDataOptions) => {
  const { enabled = true, onError, onSuccess } = options || {};
  return useQuery(
    ["geomBin", geomBinId],
    async () => {
      if (!geomBinId) {
        return null;
      }
      const result = await getGeomBin(geomBinId);
      return result;
    },
    {
      enabled: enabled && !!geomBinId,
      onError,
      onSuccess,
      // Cache for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Keep in cache for 10 minutes when unused
      cacheTime: 10 * 60 * 1000,
      // Don't retry on error
      retry: false
    }
  );
};

export default useGeomBinData;
